module.exports = __webpack_public_path__ + "img/SkidSteerLoader.f7e0c4de.png";